import { produce } from 'immer';
import {
  SET_STEP,
} from 'Src/constants';

const defaultState = {
  step: 0,
};

export default (state = defaultState, action) => {
  const { type, payload } = action;
  return produce(state, (draft) => {
    switch (type) {
      case SET_STEP:
        draft.step = payload;
        return draft;
      default:
        return state;
    }
  });
};
